export const config = {
  apiBase: "/api",
};
